import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";

import { ITicket } from "../../interfaces/ticket.interface";
import { TranslateModule } from "@ngx-translate/core";
import { LocalizedDatePipe } from '@shared/pipes/localized-date.pipe';
import { NgStyle } from '@angular/common';


@Component({
    selector: "app-management-card",
    templateUrl: "./management-card.component.html",
    styleUrls: ["./management-card.component.scss"],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    LocalizedDatePipe,
    NgStyle
  ]
})
export class ManagementCardComponent implements OnInit {
  @Input() item: ITicket;
  @Input() transactionCode: string;

  tagUserId = new UntypedFormControl();
  isActivated: boolean = false;
  isWebMobile: boolean = window.innerWidth < 600;
  events :any

  constructor() { }

  ngOnInit(): void {
    this.events = this.item.events.map(event => ({
      title: event.title,
      eventStartDateTime: event.eventStartDateTime,
      entryDateTime: event.entryDateTime,
      status: event.status
  }));
  }

}
